module.exports = __webpack_public_path__ + "img/Thinkpad_X1_Carbon_Premium_LCD_closeup_sh02.0f8dc09.jpg";